export default __webpack_public_path__ + "static/media/TheNun.e2d5efbf.jfif";